import createStore from "zustand";
import { devtools } from "zustand/middleware";
import { configurePersist } from "zustand-persist";

const { persist, purge } = configurePersist({
  storage: localStorage, // use `AsyncStorage` in react native
  rootKey: "root", // optional, default value is `root`
});

const useAuthStore = createStore(
  persist(
    {
      key: "auth",
    },
    (set) => ({
      accessToken: 0,
      setAccessToken: (current) => set(() => ({ accessToken: current })),
      name: '',
      setName: (current) => set(() => ({ name: current })),
      family: '',
      setFamily: (current) => set(() => ({ family: current })),
    })
  )
);
export default useAuthStore;
